import { Fragment } from 'react';

import type { SanityBlogPost } from '#/lib/sanity/queries/blogPost';
import { cn } from '#/lib/utils';
import { Link } from '#/components/Link';

import { Media } from './Media';

export function AuthorPreview({
  authors,
  publishedAt,
}: {
  authors: SanityBlogPost['author'];
  publishedAt?: string;
}) {
  return (
    <div className="flex items-center gap-x-10 m:gap-x-15">
      <div className="flex shrink-0">
        {authors.map((author, i) => (
          <Link
            key={author._key}
            href={author.href}
            className={cn('block shrink-0', {
              '-ml-8': i > 0,
            })}
          >
            <Media
              media={author.avatar}
              className="size-48 overflow-clip rounded-full bg-cloud ring-1 ring-cloud m:size-56"
              mediaClassName="object-cover"
              aspect={false}
              placeholder={true}
              sizes={['48px', { m: '56px' }]}
            />
          </Link>
        ))}
      </div>
      <div>
        <p className="text-14 font-[440] leading-116 text-grayscale-06 m:text-18">
          By{' '}
          {authors.map((author, i) => {
            const isLast = i === authors.length - 1;
            const isPenultimate = i === authors.length - 2;
            return (
              <Fragment key={author._key}>
                <Link href={author.href}>{author.name}</Link>
                {isPenultimate ? ' and ' : isLast ? '' : ', '}
              </Fragment>
            );
          })}
        </p>
        {authors.length === 1 && authors[0].role ? (
          <p className="mt-3 text-12 font-[440] leading-116 text-grayscale-04 m:mt-5 m:text-14">
            {authors[0].role}
          </p>
        ) : null}
        {publishedAt ? (
          <p className="mt-3 text-12 font-[440] leading-116 text-grayscale-04 m:mt-5 m:text-14">
            {new Date(publishedAt).toLocaleDateString('en-US', {
              month: 'long',
              day: 'numeric',
              year: 'numeric',
            })}
          </p>
        ) : null}
      </div>
    </div>
  );
}
